import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/baseball';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-66" data-mp="e3dj5wo89ms5">
      <div className="mx-auto max-w-6xl" data-id="element-67" data-mp="9mgn88wz35x">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-68" data-mp="58z4nwbiuga3">
          <div className="lg:col-span-7" data-id="element-69" data-mp="574h0a8v8a2b">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-70" data-mp="3mgugjv12ehuk">The BASEBALL READY™ difference</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-71" data-mp="3rhi7kgpamyos">
              From overwhelmed coach to <em className="text-red-700" data-id="element-72" data-mp="3dir0he8umda5">calm and prepared.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-73" data-mp="3ihv6xx4e1wws">
            Imagine starting your week with every practice already organized. You know what the team
            will work on – and you have the practice plans, equipment lists, drills, field diagrams,
            pitch count charts and game-day checklists.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-74" data-mp="1f8sijpa0hjic">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-75" data-mp="1t06zlqkczamr" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-76" data-mp="10dcmjepvfdjb">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-77" data-mp="wbrc000t7bca">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-78" data-mp="1ac1zqu6to9t8">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-79" data-mp="15auscw8ldcn3">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-80" data-mp="2lp4h3rgqx3eg">Before BASEBALL READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-81" data-mp="2gr2pgi597vrd">
              Sound familiar?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-82" data-mp="2oqpg0c0v873n">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-83" data-mp="2sux8mkag2775">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-84" data-mp="32r09znxh21t1" />
                  <span data-id="element-85" data-mp="32ons1arprrfz">
                    <span className="block font-semibold text-slate-900/80" data-id="element-86" data-mp="253rs02wojavs">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-87" data-mp="2f15wr598qb89">
            <p className="text-sm font-semibold text-red-300" data-id="element-88" data-mp="2jsxr7qvip13o">With BASEBALL READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-89" data-mp="1mdjuq1fnveni">
              Plan less. Coach more.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-90" data-mp="1ra0k0yyljz26">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-91" data-mp="1jq9fydj2tu7b">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-92" data-mp="1er6dn0uhe231">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="14v36thoopf9r" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-94" data-mp="w280slre7fix">
          Focus on your players – not on building every practice yourself.
        </p>
      </div>
    </section>;
}